'use client'
import { SvgIcon, type SxProps } from '@mui/material'
import BackgroundLogoSvg from '@/assets/background-logo.svg'

export function BackgroundLogo({ sx }: { sx?: SxProps }) {
  return (
    <SvgIcon viewBox="0 0 650 324" sx={sx}>
      <BackgroundLogoSvg />
    </SvgIcon>
  )
}
